import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {some, sortBy} from 'lodash';

export default function usersReducer(state = initialState.users, action) {
  switch (action.type) {
    case types.LOAD_USERS_SUCCESS:
      return {...action.users, saveError: initialState.users.saveError, lastSaved: initialState.lastSaved};
    case types.SAVE_USER_SUCCESS: {
      let users = [...state.items];
      let user = {...action.user, newPassword: '', confirmedNewPassword: ''};
      if (some(users, x => x.userId == user.userId)) {
        users = [...state.items.map(x => {
          let returnVal = {...x};
          if (returnVal.userId == user.userId) {
            return user;
          }
          return returnVal;
        })];
      } else {
        users[users.length] = user;
      }
      return {
        ...state.users,
        items: sortBy(users, x => x.userName.toLowerCase()),
        saveError: initialState.users.saveError,
        lastSaved: {user, action: 'saved'},
      };
    }
    case types.SAVE_USER_ERROR:
      return {...state, saveError: action.saveError, lastSaved: {user: action.saveError.user, action: 'error'}};
    case types.DELETE_USER_SUCCESS: {
      return {
        ...state.users,
        items: [...state.items.filter(x => x.userId != action.user.userId)],
        saveError: initialState.users.saveError,
        lastSaved: {user: action.user, action: 'deleted'}
      };
    }
    default:
      return state;
  }
}
